import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    stroke="currentColor"
    fill="transparent"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6.33333 6.33333C6.33333 5.33333 7 5 8 5C9.47276 5 10.3333 5.5621 10.3333 6.66667C10.3333 7.59963 9.48544 8.11232 8.33333 8.33333C7.79622 8.43637 7.66667 9 8 9.33333M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" />
    <ellipse
      cx="7.99967"
      cy="11.3334"
      rx="0.666667"
      ry="0.666667"
      fill="white"
    />
  </svg>
);
